import { ref } from 'vue';

export default () => {
    const show = ref(false);
    const art = ref({})

    function open(e) {
        art.value = e || {};
        show.value = true;
    }

    function close() {
        art.value = {};
        show.value = false;
    }

    return { show, open, close, art }
}